import axios, { AxiosRequestConfig, Method } from 'axios';

// Reusable Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_FAN1_API_SERVER_URL || 'http://localhost:5000',
  timeout: 10000, // 10 seconds
});

// A function to make API calls
export const callApi = async <T = any>(
  url: string,
  method: Method = 'GET',
  requiresAuth: boolean = false,
  getToken?: () => Promise<string | null>,  
  data?: any,   
  additionalHeaders: Record<string, string> = {} 
): Promise<{ data: T | null; error: any | null }> => {
  try {
    // Configure Axios request
    const config: AxiosRequestConfig = {
      url,
      method,
      headers: {
        'Content-Type': 'application/json',
        ...additionalHeaders,
      },
      data,
    };

    // Only add Authorization header if authentication is required
    if (requiresAuth && getToken) {
      const token = await getToken(); // Get the token from the `getToken` function
      if (token) {
       (config.headers ??= {}).Authorization = `Bearer ${token}`;
      } else {
        return { data: null, error: 'Failed to retrieve access token' };
      }
    }

    // Make the API request
    const response = await apiClient(config);
    return { data: response.data, error: null }; 
  } catch (error: any) {
    // Handle errors
    const errorMessage =
      error.response?.data?.message || error.response?.data || 'An unexpected error occurred';
    // console.error('API call failed:', errorMessage);
    return { data: null, error: errorMessage }; 
  }
};
